/* SpawnAnything — thumbs up/down for a freshly generated figure (POST /api/rate).
   Shows a small bar under the toast for a few seconds; one vote per figure and session in the UI
   (the server dedupes per IP as well). Never throws. */
const CSS = `.aw-rate{position:fixed;left:50%;top:calc(122px + env(safe-area-inset-top,0px));transform:translateX(-50%);z-index:9;
display:flex;gap:6px;align-items:center;background:var(--panel,#161d28);border:1px solid var(--line,rgba(205,220,255,.12));border-radius:6px;
padding:5px 6px 5px 12px;font-weight:600;font-size:14px;max-width:calc(100% - 32px);transition:opacity .3s}
.aw-rate[hidden]{display:none}
.aw-rate span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.aw-rate button{font:inherit;font-size:16px;line-height:1;padding:5px 8px;border-radius:4px;border:1px solid var(--line,rgba(205,220,255,.12));background:transparent;color:inherit;cursor:pointer}
.aw-rate button:hover{background:rgba(255,255,255,.08)}
.aw-rate button:focus-visible{outline:2px solid var(--gold,#ffc93c);outline-offset:2px}`;

let el = null, timer = 0;
const voted = new Set();

/**
 * @param {string} key   rateKey from /api/generate
 * @param {string} name  figure name for the label
 * @param {{ endpoint?: string, ms?: number }} [o]
 */
export function showRating(key, name, { endpoint = '/api/rate', ms = 12000 } = {}) {
  if (typeof document === 'undefined' || !key || voted.has(key)) return;
  if (!el) {
    const st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
    el = document.createElement('div'); el.className = 'aw-rate'; el.setAttribute('role', 'group');
    document.body.appendChild(el);
  }
  el.setAttribute('aria-label', 'Figur bewerten');
  el.innerHTML = '<span></span><button type="button" data-v="1" aria-label="Gefällt mir">👍</button><button type="button" data-v="-1" aria-label="Gefällt mir nicht">👎</button>';
  el.querySelector('span').textContent = `Gelungen: ${String(name || 'Figur').slice(0, 40)}?`;
  const hide = () => { el.style.opacity = 0; timer = setTimeout(() => { el.hidden = true; }, 300); };
  el.hidden = false; el.style.opacity = 1;
  clearTimeout(timer); timer = setTimeout(hide, ms);
  el.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
    voted.add(key);
    const vote = Number(b.dataset.v);
    el.innerHTML = `<span>${vote > 0 ? 'Danke!' : 'Danke - schlechte Figuren werden neu erzeugt.'}</span>`;
    clearTimeout(timer); timer = setTimeout(hide, 1800);
    fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ key, vote }) }).catch(() => {});
  }, { once: true }));
}
